import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InvoiceGateBatchPage = lazy(() => import("@/features/invoice-gate/pages/invoice-gate-batch"));

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/batch")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading...</div>}>
      <InvoiceGateBatchPage />
    </Suspense>
  ),
});
